import type { AtlasMission } from '../atlas.types';

export const calendarMission: AtlasMission = {
  id: 'calendar-connect',
  title: 'Connect your calendar source',
  description:
    'Wire SharePoint, sync, then learn how to use the month view, author mappings and keywords.',
  kicker: 'Guided tour',
  estimatedMinutes: 5,
  entryRoute: '/calendar',
  featureKey: 'atlas.calendarConnect',
  storage: 'atlas',
  steps: [
    {
      id: 'setup',
      title: 'Connect SharePoint in Settings',
      body: 'When you open Project Settings using the link below, complete the SharePoint section for this product. The settings page explains what to enter—you don’t need to wire anything up on the Calendar screen itself. When you’re done saving there, come back here and tap Next. If a later sync still looks empty, open Settings again and double-check that section.',
      primaryLabel: 'Next →',
    },
    {
      id: 'sync',
      title: 'Run the first sync',
      body: 'In the same row as the month name, find the green "Sync All Products" button — it will pulse on this step so you know which control to use. Click it to pull events from SharePoint. The first run can take a little while; later syncs are faster.',
      anchorId: 'calendar-sync-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'filters',
      title: 'Products in view',
      body: 'On Calendar the global product switcher in the header is hidden on purpose. In the Filters row under the month, use "Products in view" — the control is highlighted on this step. It lets owners and administrators choose which products appear on the grid. If you only see a short note under that label, your role uses one assigned product automatically. Source, Category, and Member are in the same row.',
      anchorId: 'calendar-products-in-view-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'month-view',
      title: 'Read the month view',
      body: 'Each row is a person. Colored blocks are events or absences. Hover for details and click to edit if you are the owner. Use the month arrows or Today to navigate in time.',
      anchorId: 'calendar-month-nav',
      primaryLabel: 'Next →',
    },
    {
      id: 'author-mappings',
      title: 'Match SharePoint names to Jira',
      body: 'If a name in the SharePoint calendar does not match a Jira team member, events attach to nobody. Use Saved author mappings to map the calendar spelling to the Jira name once — all past and future events update automatically.',
      anchorId: 'calendar-author-mappings-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'keywords',
      title: 'Absence keywords',
      body: 'Use this block only for words that should create an absence when they appear in a synced event title (e.g. lieu, vacation). Changes apply after SharePoint sync. Owners and administrators can use Apply to all products to add missing words on other products without removing anything.',
      anchorId: 'calendar-keywords-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'public-holiday-keywords',
      title: 'Public holiday keywords',
      body: 'This is a separate list below: matching titles are treated as public holidays on sync, not absences. Public holiday always wins over absence keywords. Edit the list here and use Apply to all products the same way as for absence keywords.',
      anchorId: 'calendar-public-holiday-keywords-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'next-releases',
      title: 'Next: plan with Releases',
      body: 'Calendar is ready. Open Releases to plan scope and capacity for the team. You can return to Calendar anytime from the header.',
      anchorId: 'nav-releases-anchor',
      primaryLabel: 'Open Releases',
    },
  ],
};
